import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';

export const verifyRecoveryTwoFactorThunk = createAppAsyncThunk<
  undefined,
  { code: string },
  { rejectValue: { message: string } }
>(
  'auth/verifyRecoveryTwoFactor',
  withLoader(
    async({ code }, { getState, extra: { authService }, rejectWithValue }) => {
      const state = getState();
      const recoveryToken = state.auth.recoveryToken;

      if (recoveryToken === undefined || typeof recoveryToken !== 'string') {
        return rejectWithValue({ message: 'Missing recovery token' });
      }

      try {
        await authService.verifyRecoveryTwoFactor({ recoveryToken, code });
        return undefined;
      } catch (caught) {
        const message =
          caught instanceof Error ? caught.message : 'Failed to verify SMS code';
        return rejectWithValue({ message });
      }
    }
  )
);
